<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h2 class="pull-left">{{ $t('monitoring.title__application_reference') }} {{ MonitoringForm.reference }}</h2>
                <el-select
                    v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN"
                    class="filter-select mr-2 mb-2"
                    style="margin-left: 10px"
                    v-model="MonitoringForm.report.status"
                    :placeholder="$t('monitoring.select__change_report_status')"
                    @change="changeReportStatus"
                >
                    <el-option v-for="item in reportStatuses" :key="item" :label="item" :value="item"/>
                </el-select>
                <el-select
                    class="pull-right"
                    v-model="visiblePage"
                    placeholder="Select page"
                    v-if="visiblePage !== 'home'"
                    @change="changeView"
                >
                    <el-option v-for="(item, key) in pages" :key="key" :label="item" :value="key" />
                </el-select>
            </div>
        </div>
        <report-monthly :key="update" v-if="MonitoringForm.report_type === 'monthly'"></report-monthly>
        <report-technical :key="update" v-if="MonitoringForm.report_type === 'technical'"></report-technical>
        <report-financial :key="update" v-if="MonitoringForm.report_type === 'financial'"></report-financial>
    </div>
</template>
<script>
    import {UserRoles, MonitoringService, MonitoringForm} from '@/services';
    import {Select, Option} from 'element-ui';

    import ReportMonthly from './Reports/Monthly';
    import ReportTechnical from './Reports/Technical';
    import ReportFinancial from './Reports/Financial';

    export default
    {
        components:
        {
            [Select.name]: Select,
            [Option.name]: Option,
            MonitoringForm,
            ReportMonthly,
            ReportTechnical,
            ReportFinancial,
        },
        data()
        {
            return {
                UserRoles,
                MonitoringForm,
                visiblePage: 'reporting',
                loggedUser: {},
                reportId: parseInt(this.$route.params.reportId) || null,
                reportStatuses:
                [
                    'UNLOCKED',
                    'LOCKED'
                ],
                pages:
                {
                    'home': 'Home',
                    'grant-agreement': 'Grant Agreement',
                    'approved-logframe': 'Approved Logframe',
                    // 'project-team': 'Project Team',
                    'reporting': 'Reporting',
                },
                update: 0
            }
        },
        beforeMount()
        {
            this.loggedUser = this.$store.getters['Auth/loggedUser'];
        },
        methods:
        {
            changeView()
            {
                MonitoringForm.visible_page = this.visiblePage;

                this.$router.push('/monitoring/edit/' + MonitoringForm.grantId + '/' + MonitoringForm.applicationId);
            },

            async changeReportStatus()
            {
                const vm = this;

                if (confirm(vm.$t('monitoring.confirm__change_proposal_status')))
                {
                    MonitoringService.updateReportStatus(
                    {
                        report_id: vm.reportId,
                        status: MonitoringForm.report.status,
                    }).then(function (response)
                    {
                        MonitoringForm.report.status = response.data.status;
                        MonitoringForm.report.locked = MonitoringForm.report.status === 'LOCKED';
                        MonitoringForm.isEditable = MonitoringForm.report.status !== 'LOCKED';
                        vm.update += 1;
                    });
                }
            },
        },
    };
</script>
<style lang="scss">
    .mt-card
    {
        height: 100%;
    }
</style>
